export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Если вы это видите, форма не была получена (но вы не должны это видеть)"])}
}